import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { toast } from "sonner";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const token = sp.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Passwort geändert"); navigate("/login"); }
    catch (e2) { setErr(formatError(e2.response?.data?.detail)); }
  };
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Logo className="justify-center" /></div>
        <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
          <h1 className="text-2xl font-bold font-display">Neues Passwort</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required type="password" placeholder="Neues Passwort" data-testid="reset-password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-xl border border-gray-200" />
            {err && <div className="text-sm text-[#E0243A]">{err}</div>}
            <button data-testid="reset-submit" className="w-full bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-3 rounded-xl">Passwort speichern</button>
          </form>
          <div className="mt-4 text-sm text-center"><Link to="/login" className="text-[#E0243A] font-semibold">Zur Anmeldung</Link></div>
        </div>
      </div>
    </div>
  );
}
